import L from 'leaflet'

export const labelPinHtml = (color, label = '') => {
  const text = String(label ?? '')
  const size = text.length > 2 ? 10 : 13
  return `<div class="map-pin">
      <svg width="30" height="38" viewBox="0 0 30 38" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 0C6.7 0 0 6.7 0 15c0 10.5 15 23 15 23s15-12.5 15-23C30 6.7 23.3 0 15 0z" fill="${color}" stroke="#fff" stroke-width="2.5"/>
        <text x="15" y="19.5" text-anchor="middle" font-size="${size}" font-weight="700" fill="#fff" font-family="-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif">${text.replace(/[<>&"]/g, '')}</text>
      </svg>
    </div>`
}

export const labelPinIcon = (color, label) => L.divIcon({
  className:   '',
  iconSize:    [30, 38],
  iconAnchor:  [15, 36],
  popupAnchor: [0, -34],
  html:        labelPinHtml(color, label)
})
